import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image/refresh.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7561f588")

_pushScopeId("data-v-7561f588")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "reportConfirm_title" }, [
  /*#__PURE__*/_createVNode("h3", null, "检测结果确认"),
  /*#__PURE__*/_createVNode("p", null, "请仔细核对检测结果，避免录入错误导致驳回哦")
], -1)
const _hoisted_2 = { class: "reportConfirm_notice" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("缺陷与漆膜不一致")
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_notice_bar = _resolveComponent("van-notice-bar")
  const _component_reportConformCarInfo = _resolveComponent("reportConformCarInfo")
  const _component_reportContent = _resolveComponent("reportContent")

  return (_openBlock(), _createBlock("div", {
    class: ["reportConfirm", {"pb144": _ctx.isAndroid}]
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.paintResult, (item) => {
        return (_openBlock(), _createBlock(_component_van_notice_bar, {
          class: "reportConfirm_notice_item",
          "left-icon": "warning",
          background: "#FFF7D4",
          mode: "link",
          scrollable: false,
          key: item.itemCode,
          onClick: _ctx.goToDetectPage
        }, {
          default: _withId(() => [
            _createVNode("span", null, [
              _createVNode("b", null, _toDisplayString(item.itemName.split(',')[0]) + "，", 1),
              _hoisted_3
            ])
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128))
    ]),
    _createVNode(_component_reportConformCarInfo, {
      reportData: _ctx.state.data.reportData
    }, null, 8, ["reportData"]),
    _createVNode(_component_reportContent, {
      reportData: _ctx.state.data.reportData
    }, null, 8, ["reportData"]),
    _createVNode("div", {
      class: "refresh",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
    }, [
      _hoisted_4
    ])
  ], 2))
})